// 表单配置信息
export const collapse = [
    {
        title: '基本信息',
        ref: 'baseForm',
        formName: 'baseInfo',
        col: 4,
        labelWidth: '150px',
        visible: true,
        formList: [
            {
                label: '客户系名称',
                prop: 'customerGroupName',
                value: 'customerGroupName',
                type: 'custom'
            },
            {
                label: '客户系编码',
                prop: 'customerGroupCode',
                value: 'customerGroupCode',
                type: 'custom'
            },
            {
                label: 'TOP客户系编码',
                prop: 'topCustomerGroupCode',
                value: 'topCustomerGroupCode',
                type: 'custom'
            },
            {
                label: '客户等级',
                prop: 'customerLevelCode',
                value: 'customerLevelCode',
                type: 'custom',
                optionsKey: 'NEOCRM_CUSTOMER_LEVEL'
            },
            {
                label: '客户经理',
                prop: 'customerManagerName',
                value: 'customerManagerName',
                type: 'custom'
            },
            {
                label: '客户经理MIP',
                prop: 'customerManager',
                value: 'customerManager',
                type: 'custom'
            },
            {
                label: '行业大类',
                prop: 'industryCategory',
                value: 'industryCategory',
                type: 'custom'
            },
            {
                label: '行业类型',
                prop: 'industryType',
                value: 'industryType',
                type: 'custom'
            },
            {
                label: '状态',
                prop: 'enableFlag',
                value: 'enableFlag',
                type: 'custom',
                optionsKey: 'SYS_BMS_EX_RELATION_STATUS'
            }
        ]
    },
    {
        title: '一页纸信息',
        ref: 'onePagerForm',
        formName: 'onePagerInfo',
        col: 4,
        labelWidth: '150px',
        visible: true,
        formList: [
            {
                label: '本季度一页纸新增数',
                prop: 'currentQuarterCount',
                value: 'currentQuarterCount',
                type: 'custom'
            },
            {
                label: '历史一页纸数量',
                prop: 'totalHistoryCount',
                value: 'totalHistoryCount',
                type: 'custom'
            }
        ]
    },
    {
        title: '系统信息',
        ref: 'systemForm',
        formName: 'systemInfo',
        col: 4,
        labelWidth: '150px',
        visible: true,
        formList: [
            {
                label: '创建人名称',
                prop: 'createUserName',
                value: 'createUserName',
                type: 'custom'
            },
            {
                label: '创建人MIP',
                prop: 'createUserCode',
                value: 'createUserCode',
                type: 'custom'
            },
            {
                label: '创建时间',
                prop: 'createTime',
                value: 'createTime',
                type: 'custom'
            },
            {
                label: '修改人名称',
                prop: 'updateUserName',
                value: 'updateUserName',
                type: 'custom'
            },
            {
                label: '修改人MIP',
                prop: 'updateUserCode',
                value: 'updateUserCode',
                type: 'custom'
            },
            {
                label: '修改时间',
                prop: 'updateTime',
                value: 'updateTime',
                type: 'custom'
            }
        ]
    }
];
